import * as React from 'react';
import { Zoom } from '@mui/material';
import ApiService from 'services/ApiService';
import styles from "../css/gis.module.css";

export const PopupViewVms = ({ item }) => {
    const [transitionIn, setTransitionIn] = React.useState(false);
    const [dspBytes, setDspBytes] = React.useState(null);

    // 오버플로우 상태 체크용
    const nmRef = React.useRef(null);
    const [nmOverflow, setNmOverflow] = React.useState(false);

    React.useEffect(() => {
        setTransitionIn(false);
        const key = setTimeout(() => {
            setTransitionIn(true);

            // overflow 체크
            if (nmRef.current) {
                const el = nmRef.current;
                const overflow = el.scrollWidth > el.clientWidth;
                console.log("scroll check:", el.scrollWidth, el.clientWidth, overflow);
                setNmOverflow(overflow);
            }

            // API 호출
            ApiService.get(`newdashboard/gis/GetDspImage?vmsId=${item.id}`).then(response => {
                if (response.status === 200) {
                    setDspBytes(response.data.dspBytes);
                }
            });

        }, 400);

        return () => clearTimeout(key);
    }, [item.id, item.nm]);

    return (
        <Zoom in={transitionIn} timeout={300} easing={{ enter: "ease-out", exit: "ease-in" }}>
            <div className={`${styles.gisPopup_vms} gisPopup flx flx_col gap6`} style={{ width: '400px' }}>
                <div className='flx a_center'>
                    <div className='popTit'>VMS</div>
                    <div className={`${styles.flow_wrap_vms} flow_wrap`} ref={nmRef}>
                        <span className={`flow_txt id ${nmOverflow ? "animate-delay" : ""}`}>
                            {item.nm}
                        </span>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', margin: '10px' }}>
                    <div style={{ border: '1px solid white' }}>
                        <img
                            alt='dspImg'
                            style={{ maxHeight: '192px', display: 'block' }}
                            src={`data:image/png;base64,${dspBytes}`}
                        />
                    </div>
                </div>
                <div className='popConts flx j_spc_btw gap20'>
                    <div className='flx flx_col gap10'>
                        <div className='flx a_center j_spc_btw'>
                            <div className='popTit'>상태</div>
                            {item.stat === 1 ? <div className='gr'>정상</div> : <div className='rd'>장애</div>}
                        </div>
                        <div className='flx a_center j_spc_btw'>
                            <div className='popTit'>ID</div>
                            <div>{item.id}</div>
                        </div>
                    </div>
                    <div>
                        <img width='200' height='120' src='/images/facility/vms_thumbnail_2.jpg' alt='thumbnail' />
                    </div>
                </div>
            </div>
        </Zoom>
    );
};
